import queryString from 'query-string'
import {
  fetchKoalaData
} from 'apis/koala'

export const fetchMyMazdaComponents = async (url) => {
  const response = await fetch(url, {
    method: 'POST',
    credentials: 'include'
  })
  if (response.status !== 200) throw new Error(`Failed with status ${response.status}`)

  const {
    data,
    errorMsg,
    errorCode,
    success
  } = await response.json()

  if (!success) {
    return {
      errorMsg,
      errorCode
    }
  }

  return {
    data
  }
}

export const removeMyMazdaVehicle = (endpoint, data) =>
  fetchKoalaData(endpoint, data, {
    method: 'DELETE',
    credentials: 'include'
  })

export const queryMyMazdaVinRego = (endpoint, vinRego) =>
  fetchKoalaData(endpoint + '?' + queryString.stringify({
    vinRego
  }))

export const linkMyMazdaVinRego = (endpoint, vin) =>
  fetchKoalaData(endpoint + '?' + queryString.stringify({
    vin
  }), {}, {
    credentials: 'include'
  })

export const deactivateAccount = (endpoint, password) =>
  fetchKoalaData(endpoint, {
    password
  }, {
    credentials: 'include',
    method: 'DELETE'
  })

export const verifyMymazdaEmail = (endpoint, payload) =>
  fetchKoalaData(endpoint + '?' + queryString.stringify(payload), {}, {
    credentials: 'include'
  })

export const resendMyMazdaVerificationEmail = endpoint =>
  fetchKoalaData(endpoint, {}, {
    credentials: 'include'
  })



// WEBPACK FOOTER //
// ./src/apis/mymazda.js